import { render, staticRenderFns } from "./nomination-tabs.vue?vue&type=template&id=6fd51cfa&scoped=true"
import script from "./nomination-tabs.vue?vue&type=script&lang=js"
export * from "./nomination-tabs.vue?vue&type=script&lang=js"
import style0 from "./nomination-tabs.vue?vue&type=style&index=0&id=6fd51cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd51cfa",
  null
  
)

export default component.exports